export default "__VITE_ASSET__BX4VN75s__"